import { Component } from '@angular/core';

@Component({
  selector: 'private-views',
  templateUrl: './private-views.component.html'
})
export class PrivateViewsComponent {
  public disabled = false;
  public status: { isopen: boolean } = { isopen: false };

  public toggled(open: boolean): void {
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }
}



// WEBPACK FOOTER //
// ./src/app/private-views/private-views.component.ts